import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { Role } from "@/classes";
import { useListStore } from "@/store/lists";

import { ref } from "vue";
import { VAutocomplete } from "vuetify/lib/components/index.mjs";
import { setupApiQueue } from "../base/api-queue";


export default /*#__PURE__*/_defineComponent({
  __name: 'RoleAutocomplete',
  props: /*#__PURE__*/_mergeModels({
    readonly: { type: Boolean, default: false }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props;

const model = _useModel(__props, "modelValue");
const lists = useListStore();
const roles = lists.useList<Role>("roles");

const search = ref<string>("");

const { queueApiAction, loading } = setupApiQueue();

const newRole = (name: string) => {
  queueApiAction(async () => {
    const oldRole = roles.value.find((r) => r.name === name);
    if (oldRole) {
      model.value = oldRole.id;
    } else {
      const role = new Role();
      role.name = name;
      model.value = role.id;
      await role.save();
      lists.refreshList("roles");
    }
  });
};

return (_ctx: any,_cache: any) => {
  const _component_v_list_item = _resolveComponent("v-list-item")!

  return (_openBlock(), _createBlock(_unref(VAutocomplete), {
    variant: "plain",
    modelValue: model.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((model).value = $event)),
    search: search.value,
    "onUpdate:search": _cache[2] || (_cache[2] = ($event: any) => ((search).value = $event)),
    items: _unref(roles),
    "item-title": "name",
    "item-value": "id",
    placeholder: "Role",
    loading: !!_unref(loading),
    readonly: _ctx.readonly,
    ref: "autocomplete"
  }, {
    "append-item": _withCtx(() => [
      (search.value)
        ? (_openBlock(), _createBlock(_component_v_list_item, {
            key: 0,
            selectable: "",
            title: "Create New Role",
            value: "new",
            loading: !!_unref(loading),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (newRole(search.value)))
          }, null, 8, ["loading"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue", "search", "items", "loading", "readonly"]))
}
}

})